module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Quote2-d66293d0535acfc0a5791369a53bb6c4.svg";